import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getSelectedMatchRefereeAssistantsRequest } from '~/store/modules/matches/actions';
import { Table, Icon } from '~/components';
import { theme } from '~/styles/theme';
import * as S from './styles';
import tableStructure from './utils/tableStructure';
import ArbitrationBlock from '../ArbitrationBlock';

export default function ArbitrationAssistanceBlock({
  selectedAssistant,
  setSelectedAssistant,
  tabMode,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    selectedMatch: { data: selectedMatch },
    refereeAssistants: { data: refereeAssistants, loading },
  } = useSelector(state => state.matches);
  useEffect(() => {
    if (
      selectedMatch &&
      Object.keys(refereeAssistants).length === 0 &&
      !loading
    ) {
      dispatch(getSelectedMatchRefereeAssistantsRequest(selectedMatch.id));
    }
  }, [dispatch, selectedMatch, refereeAssistants, loading]);

  const columns = React.useMemo(
    () =>
      tableStructure(
        refereeAssistants,
        selectedAssistant,
        setSelectedAssistant
      ),
    [refereeAssistants, selectedAssistant, setSelectedAssistant]
  );
  const tableStyles = {
    secondaryColor: theme.light2Opacity,
    textColor: theme.dark,
    fullWidth: true,
  };

  const styleTabPrimary = {
    colorPrimary: theme.black,
    secondaryColor: theme.white,
    contrastColor: theme.white,
    textColor: theme.white,
  };
  return (
    <S.ContainerArbitration>
      {!tabMode && (
        <S.Container>
          <S.TableContent selectedAssistant={selectedAssistant}>
            {Object.keys(refereeAssistants).length > 0 &&
              refereeAssistants.arbitratedMatchesTable && (
                <Table
                  header={<S.Title>{t('matchesWithReferees')}</S.Title>}
                  data={refereeAssistants.arbitratedMatchesTable.seasons}
                  columns={columns}
                  styleOptions={tableStyles}
                  fullWidth
                  hasFooter
                  disableSort
                />
              )}
          </S.TableContent>
        </S.Container>
      )}
      {tabMode && (
        <S.ListContent>
          {Object.keys(refereeAssistants).length > 0 &&
          refereeAssistants.arbitratedMatchesTable
            ? refereeAssistants.referees.map((item, index) => {
                return (
                  <>
                    <S.TabButtonFullWidth
                      isOpen={index === selectedAssistant}
                      styleButton={styleTabPrimary}
                      value={index}
                      onChange={({ value }) => {
                        setSelectedAssistant(value);
                      }}
                      label={
                        <>
                          <S.ContainerProfile>
                            <S.ProfileImg src={item.photoUrl} />
                            <S.ProfileRole>{t(item.role)}</S.ProfileRole>
                            <S.ProfileName>{item.refereeName}</S.ProfileName>
                          </S.ContainerProfile>
                          <Icon name="chevronRight" size={12} color="coral" />
                        </>
                      }
                    />
                    <S.TabContent isOpen={index === selectedAssistant}>
                      <ArbitrationBlock
                        name={item.refereeName}
                        avatar={item.photoUrl}
                        arbitrationCollege={item.refereeSchool}
                        matches={item.seasonsGlobalStats}
                        totalMatches={{
                          ...item.acumulatedStats,
                          season: 'TOTAL',
                        }}
                        localStats={item.homeTeamSeasonsStats}
                        awayStats={item.awayTeamSeasonsStats}
                        selectedMatch={selectedMatch}
                      />
                    </S.TabContent>
                  </>
                );
              })
            : null}
        </S.ListContent>
      )}
    </S.ContainerArbitration>
  );
}

ArbitrationAssistanceBlock.propTypes = {
  selectedAssistant: PropTypes.number,
  setSelectedAssistant: PropTypes.func,
  tabMode: PropTypes.bool,
};

ArbitrationAssistanceBlock.defaultProps = {
  selectedAssistant: 0,
  setSelectedAssistant: () => {},
  tabMode: false,
};
